export default "__VITE_ASSET__B8eOYx$7__"